import ScootersModal from './ScootersModal';
export default ScootersModal;
